import React, { useEffect, useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {FiMenu, FiX} from "react-icons/fi";
import Logo from "../../assets/Logo.png";
import Scroll from "../layout/Scroll";


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const navigate = useNavigate();

  const handleLogoClick = () =>{
    navigate("/");
    window.location.reload();
  }

  useEffect(() => {
    
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 100) {
        setIsScrolled (true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // const linkClass = isScrolled
  // ? "text-pink-700 font-bold hover:text-pink-200 transition-all duration-300 "
  // : "text-pink-700 font-bold hover:text-pink-200 transition-all duration-300 "

   const linkClass = `relative pb-1 font-bold hover:text-pink-200 cursor-pointer transition-all duration-300 ${
    isScrolled ? "text-pink-700" : "text-pink-700"
  } hover:after:content-[''] hover:after:h-0.5 hover:after:bg-pink-500`;

  const activeLinkClass = `after:content-[''] after:absolute 
  after:left-0 after:bottom-0 
  after:w-full after:h-0.5 after:bg-pink-200 
  after:transition-all after:duration-300`;

  const navClass = `w-full shadow-md fixed top-0 left-0 z-50 p-2 px-6 flex justify-between 
                  items-center transition-all duration-500 ${
    isScrolled
    // backdrop-blur-md
      ? "bg-white drop-shadow-md/50"
      : "bg-white drop-shadow-md/50 "
  }`;

  return (
    <nav className={navClass}> 
      
      {/* Logo*/}
      <RouterLink to='/' className="flex items-center gap-2">
        <img src= {Logo} 
        alt="Logo" 
        className="w-20 h-20"
        onClick={handleLogoClick}/>
      </RouterLink>

      {/* Desktop Menu */}      
    <ul className="hidden md:flex gap-6 text-xl font-semibold" >
      <li>
        <RouterLink to='/' 
          className={linkClass}
          >
          HOME
        </RouterLink>
      </li>
      <li>
        <RouterLink to='/Menu' 
          className={`${linkClass} ${activeLink === "menu"? activeLinkClass : ""}`} 
          onClick={() => setActiveLink("menu")}>
          MENU
        </RouterLink>
      </li>
      <li>
        <RouterLink to="/promo" smooth={true} duration={500} offset={-80} 
          className={`${linkClass} ${activeLink === "promo" ? activeLinkClass : ""}`}>
          PROMO
        </RouterLink>
      </li>
      <li>
        <RouterLink to="/#location" 
          className={`${linkClass} ${activeLink === "location" ? activeLinkClass : ""}`}>
          LOCATION
        </RouterLink>
      </li>
      <li>
        <ScrollLink to="contact" smooth={true} duration={500} offset={-80} 
          className={`${linkClass} ${activeLink === "contact" ? activeLinkClass : ""}`}>
          CONTACT US
        </ScrollLink>
      </li>
      <li>
        <ScrollLink to="contact" smooth={true} duration={500} offset={-80} 
          className={`${linkClass} ${activeLink === "about" ? activeLinkClass : ""}`}>
          ABOUT
        </ScrollLink>
      </li>
    </ul>

{/* Mobile Menu */}
      <div className="md:hidden pr-3">
        <button onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>
{/* Mobile Menu Content */}
      {isOpen && (
        <div className={`absolute top-28 left-0 w-full p-4 md:hidden transition-all duration-500 ${isScrolled ? "bg-white/10 backdrop-blur-md" : "bg-white/10 backdrop-blur-md"}`}>
          <ul className="flex flex-col gap-4 text-center">
          <li><RouterLink to="/" onClick={() => setIsOpen(false)} className={linkClass}>HOME</RouterLink></li>
          <li><RouterLink to="/Menu" onClick={() => setIsOpen(false)} className={linkClass}>MENU</RouterLink></li>
          <li><RouterLink to="/promo" smooth={true} duration={500} offset={-80} onClick={() => setIsOpen(false)} className={`cursor-pointer ${linkClass}`}>PROMO</RouterLink></li>
          <li><RouterLink to="/#location" onClick={() => setIsOpen(false)} className={linkClass}>LOCATION</RouterLink></li>
          <li><ScrollLink to="/contact" smooth={true} duration={500} offset={-80} onClick={() => setIsOpen(false)} className={linkClass}>CONTACT</ScrollLink></li>
          <li><RouterLink to="/About" onClick={() => setIsOpen(false)} className={linkClass}>ABOUT US</RouterLink></li>
          </ul>
        </div>
      )}
      <Scroll/>
    </nav>
  );
};

export default Navbar;
